import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { OfferFormView } from "../features/offers/offer-form";
import { Require } from "../features/require";

/** An offer from More > Offers (P9-T09). */
export const Route = createFileRoute("/more/offers/$offerId")({ component: Page });

function Page() {
	const { offerId } = Route.useParams();
	const navigate = useNavigate();
	const done = () => void navigate({ to: "/more/offers" });
	return (
		<Require permission="offers.manage">
			<OfferFormView key={offerId} offerId={offerId} onSaved={done} onDeleted={done} />
		</Require>
	);
}
